import React from 'react'
import LayoutComp from '../../../layout/LayoutComp'
import SportsComp from '../../../components/promotions/viewall/category/SportsComp'

const Sports = () => {
    return (
        <LayoutComp>
            <SportsComp />
        </LayoutComp>
    )
}

export default Sports